import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { USER_PROMOCODE, PAGE_LIMIT } from "helpers/viewContent";
import { FORMAT_TEXT, DATE_FORMAT_TIME } from "helpers/common";
import ReactPagination from "components/shared/ReactPagination";
import { PRODUCT_IMG } from "utils/constant";

import ContentLoader_ from "helpers/ContentLoader_";
//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import { getList_, deleteData_, updateData_ } from "store/services/commonService";

const Listing = ({ dispatch, itemsCountPerPage, totalItemsCount, loader }) => {
  const history = useHistory();

  //pagination
  const [activePage, setActivePage] = useState(1);
  const [listing, setListing] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      let query = {
        url: "promocode/coupon_list",
        page: activePage,
        limit: PAGE_LIMIT,
        common: false,
        search_string: searchValue,
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader:false}));
      let res = await dispatch(getList_(query));
      setListing(res?.body?.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };
  let timeout;
  const debounced = function (func, delay) {
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  };

  useEffect(() => {
    fetchData();
  }, [activePage, searchValue]);

  const handleSearchChange = (event) => {
    const inputValue = event.target.value;
    setSearchValue(inputValue);

    // Check if the input value has at least 3 characters before making the API call
    if (inputValue.length >= 3) {
      debounced(() => fetchData(), 2000);
    }
  };

  //pagination
  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };
  const clearSerchFilter = () => {
    setSearchValue("");
    fetchData();
  };
  return (
    <>
      <Helmet title={USER_PROMOCODE.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-account-multiple menu-icon"></i>
          </span>{" "}
          {USER_PROMOCODE.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.user_promocode}>{USER_PROMOCODE.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Listing
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <div className="row">
                  <div className="col-md-6">Listing</div>
                  <div className="col-md-6">
                    <div class="add-items d-flex">
                      <input
                        className="form-control"
                        autoComplete="chrome-off"
                        name="searchUnique"
                        type="text"
                        placeholder="Search by code / first name / last name"
                        value={searchValue}
                        onChange={handleSearchChange}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        id="add-task"
                        onClick={clearSerchFilter}
                      >
                        <i class="mdi mdi-close-circle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </h4>
              <div class="table-responsive actionSticky">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th> First Name </th>
                      <th> Last Name </th>
                      <th> Code </th>
                      <th> Charges </th>
                      <th> Date </th>
                      <th> Is Expired </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                    {isLoading ? (
                      <div className="loader-class">
                        <ContentLoader_ />
                      </div>
                    ) : (
                      <>
                      <tbody>
                        {listing.length > 0 &&
                          listing.map((list, i) => {
                            return (
                              <tr key={i}>
                                <td className="py-1 cursor-pointer" title="View" onClick={() => history.push(`${Path.userview}/${list?.user?.id}`)}>
                                     <a href={list?.user?.image ? `${list?.user?.image}` : "#"} target="_blank">
                                        <img
                                          src={list?.user?.image ? `${list?.user?.image}` : PRODUCT_IMG}
                                          className="custom-img"
                                        />
                                      </a>
                                    &nbsp;&nbsp;<b>{list?.user?.name ? FORMAT_TEXT(list?.user?.name) : "N/A"}</b>
                                </td>
                                <td className="py-1">
                                  {list?.user?.last_name ? FORMAT_TEXT(list?.user?.last_name) : "N/A"}
                                </td>
                                <td>{list?.code ? FORMAT_TEXT(list?.code) : "N/A"} </td>
                                <td>{list?.promo_code?.charges ? `$ ${list?.promo_code?.charges}` : "N/A"} </td>
                                <td>
                                  {list?.date
                                    ? DATE_FORMAT_TIME(list?.date)
                                    : "N/A"}
                                </td>
                                <td>
                                  <label
                                    className={`badge badge-gradient-${
                                      list?.promo_code?.is_expired === "1" ? "success" : "danger"
                                    }`}
                                  >
                                    {list?.promo_code?.is_expired === "1" ? "Yes" : "No"}
                                  </label>
                                </td>
                                <td>
                                  <Link to={`${Path.userpromocodeview}/${list?.id}`}>
                                    <label
                                      className="btn btn-sm btn btn-gradient-info"
                                      style={{ cursor: "pointer" }}
                                      title="View"
                                    >
                                      <i className="mdi mdi-eye"></i>
                                    </label>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                      </>
                    )}
                </table>
              </div>
              {listing.length > 0 && (
                <div className="pagination-box-review">
                  <ReactPagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalItemsCount}
                    handlePageChange={handlePageChange}
                  />
                </div>
              )}
              {!isLoading && listing.length == 0 && (
                <div className="row">
                  <div className="col-md-6 pt-5">
                    <span>No data found...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Common.itemsCountPerPage,
    totalItemsCount: state.Common.totalItemsCount,
    loader: state.Common.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
